import { render, staticRenderFns } from "./GenericControlVulnerability.vue?vue&type=template&id=27fe8132&scoped=true&"
import script from "./GenericControlVulnerability.vue?vue&type=script&lang=js&"
export * from "./GenericControlVulnerability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe8132",
  null
  
)

export default component.exports